/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getDistanceMax,
  getDistanceMinPositive,
  getForceMax,
  getForceMinPositive
} from "../../store/data/cartesianData";
import {
  selectMechanics,
  setMechanics,
  setSelectedMechanicsField,
  setSelectedMechanicsFieldIndex
} from "../../store/slices/cartesian";
import { FORCE_PARAMETERS_FIELD, validateForceParamRow } from "../../../Common/utils/api/common";
import t from "../../../Common/utils/translation/translator";
import MsxIcons from "../../../Common/components/Icons/MsxIcons/MsxIcons";
import ForcesParametersRows from "../ForcesParametersRows/ForcesParametersRows";
import "./ForcesParameters.scss";

const FX = "Fx";
const FY = "Fy";
const FZ = "Fz";
const DX = "dx";
const DY = "dy";
const DZ = "dz";
const FORCE_MAX = getForceMax();
const FORCE_MIN_POSITIVE = getForceMinPositive();
const DISTANCE_MAX = getDistanceMax();
const DISTANCE_MIN_POSITIVE = getDistanceMinPositive();

const ForceParameterHeader = ({ name, inputClass, ...props }) => (
  <div
    className={`ForceParameterHeader ${inputClass} bd-white text-gray-600 text-sm bg-white border-b-[1px] border-b-[#008a16] border-solid`}
    role="columnheader"
    {...props}
  >
    {name}
  </div>
);

const CenterOfForceSection = ({ errorTitle, ...props }) => (
  <div className="CenterOfForceSection fp-flex-table header" role="rowgroup" {...props}>
    <div className="fp-flex-row-small fp-topograph fp-table-border-left fp-table-border-right" role="columnheader" />
    <div className="fp-flex-row-large-start text-red-600" role="columnheader">
      {errorTitle && (
        <>
          <MsxIcons name="alert" size="nano" />
          <div className="text-sm flex justify-start">{t("msizer.ui.mandatory_field_missing")}</div>
        </>
      )}
    </div>
    <div
      className="fp-flex-row-center-load text-gray-600 text-sm bg-white border-solid break-words"
      role="columnheader"
    >
      {t("cartesian.ui.mechanics.force_parameters.force")}
    </div>
    <div className="w-[5px]" />
    <div className="fp-flex-row-center-load1 bd-white text-gray-600 text-sm bg-white border-solid" role="columnheader">
      {t("cartesian.ui.mechanics.force_parameters.point_of_application_of_force")}
    </div>
  </div>
);

const CenterOfTableHeaderSection = ({ ...props }) => (
  <div className="CenterOfTableHeaderSection fp-flex-table header" role="rowgroup" {...props}>
    <div className="fp-flex-row-small-header bd-white fp-topography bg-white" role="columnheader">
      <div className="fp-header-start-sep-first border-left" />
      <div className="fp-header-start-sep-second border-b-[1px] border-b-[#008a16]" />
    </div>
    <ForceParameterHeader
      data-testid="force-parameter-center-title"
      name={t("cartesian.ui.mechanics.force_parameters_title")}
      inputClass="fp-flex-row-large-header"
    />
    <ForceParameterHeader data-testid={`force-parameter-center-${FX}`} name={FX} inputClass="fp-flex-row-header" />
    <ForceParameterHeader data-testid={`force-parameter-center-${FY}`} name={FY} inputClass="fp-flex-row-header" />
    <ForceParameterHeader data-testid={`force-parameter-center-${FZ}`} name={FZ} inputClass="fp-flex-row-header" />
    <ForceParameterHeader data-testid={`force-parameter-center-${DX}`} name={DX} inputClass="fp-flex-row-header" />
    <ForceParameterHeader data-testid={`force-parameter-center-${DY}`} name={DY} inputClass="fp-flex-row-header" />
    <ForceParameterHeader data-testid={`force-parameter-center-${DZ}`} name={DZ} inputClass="fp-flex-row-header" />
    <div className="fp-flex-row-small-header bd-white fp-topography bg-grey" role="columnheader">
      <div className="fp-header-start-sep-first" />
      <div className="fp-header-start-sep-first" />
    </div>
  </div>
);

const ForceParameterTableSection = ({ errorTitle, ...props }) => (
  <div className="ForceParameterTableSection fp-table-container" role="table" {...props}>
    <CenterOfForceSection data-testid="center-of-force-section" errorTitle={errorTitle} />
    <CenterOfTableHeaderSection data-testid="center-of-table-header-section" />
  </div>
);

const AddSection = ({ onClick, isDisabled, ...props }) => (
  <div className="AddSection fp-add-section" {...props}>
    <AddButtonSection data-testid="add-button-section" onClick={onClick} isDisabled={isDisabled} />
    <AddForceSection data-testid="add-force-section" onClick={onClick} isDisabled={isDisabled} />
  </div>
);

const AddForceSection = ({ onClick, isDisabled, ...props }) => (
  <button disabled={isDisabled} type="button" onClick={onClick} className="AddForceSection fp-add-load" {...props}>
    {t("cartesian.ui.mechanics.load_parameters_add_force")}
  </button>
);

const AddButtonSection = ({ onClick, isDisabled, ...props }) => (
  <div className="AddButtonSection fp-add-load-button-top" {...props}>
    <button disabled={isDisabled} type="button" onClick={onClick} className="fp-add-load-button">
      action_add_flat
    </button>
  </div>
);

const ForcesParametersHeaderSection = ({ ...props }) => (
  <div
    className="ForcesParametersHeaderSection h-[34px] bg-primary flex items-center w-full fp-table-border-bottom"
    {...props}
  >
    <div className="fp-header">{t("cartesian.ui.mechanics.force_parameters")}</div>
  </div>
);

const ForcesParameters = ({ ...props }) => {
  const dispatch = useDispatch();
  const mechanics = useSelector(selectMechanics);
  const [indexSelected, setIndexSelected] = useState(-1);

  const dispatchMechanics = (newRowData, index, field) => {
    const newData = {
      ...mechanics,
      forcesParameters: newRowData,
      selectedIndex: index,
      selectedField: field
    };
    dispatch(setMechanics(newData));
  };

  let errorTitle = false;
  const fps = [...mechanics.forcesParameters];
  for (let index = 0; index < fps.length; index++) {
    errorTitle =
      errorTitle ||
      validateForceParamRow(
        fps[index].title,
        fps[index].fx,
        fps[index].fy,
        fps[index].fz,
        fps[index].dx,
        fps[index].dy,
        fps[index].dz
      );
  }

  const getNewIndex = (forceparams) => {
    let max = 0;
    const forceName = t("cartesian.ui.mechanics.load_parameters.force");
    for (let index = 0; index < forceparams.length; index++) {
      const { title } = forceparams[index];
      const loadindex = title.match(forceName + " [0-9]+") ? Number(title.replace(forceName + " ", "").trim()) : 0;
      max = Math.max(max, loadindex);
    }
    return max + 1;
  };

  const addRowTable = () => {
    const newIndex = getNewIndex(mechanics.forcesParameters);
    const forceName = t("cartesian.ui.mechanics.load_parameters.force");
    const data = {
      id: new Date().getTime(),
      enable: !(mechanics.forcesParameters.length > 0),
      title: `${forceName} ${newIndex}`,
      fx: "0",
      fy: "0",
      fz: "0",
      dx: "0",
      dy: "0",
      dz: "0"
    };
    const newRowData = [...mechanics.forcesParameters, data];
    dispatchMechanics(newRowData, newRowData.length - 1, FORCE_PARAMETERS_FIELD);
  };

  const tableRowRemove = (index) => {
    const dataRow = [...mechanics.forcesParameters];
    dataRow.splice(index, 1);
    dispatchMechanics(dataRow, dataRow.length - 1, FORCE_PARAMETERS_FIELD);
  };

  const handleInputFocusIn = (i) => {
    setIndexSelected(i);
    /* const data = [...mechanics.forcesParameters];
    let isEnableChanged = false;
    for (let index = 0; index < data.length; index++) {
      // eslint-disable-next-line no-useless-computed-key
      if (i === index && !data[index].enable) {
        isEnableChanged = true;
      }
      data[index] = { ...data[index], enable: i === index };
    }
    if (isEnableChanged) {
      dispatchMechanics(data, i, FORCE_PARAMETERS_FIELD);
    } else { */
    dispatch(setSelectedMechanicsField(FORCE_PARAMETERS_FIELD));
    dispatch(setSelectedMechanicsFieldIndex(i));
    //}
  };

  const handleInputFocusOut = () => {
    /*
    setIndexSelected(-1);
    const data = [...mechanics.forcesParameters];
    dispatchMechanics(data, -1, "");
    */
  };

  const onValUpdateFP = (i, event) => {
    const { name, checked } = event.target;
    let { value } = event.target;
    const data = [...mechanics.forcesParameters];

    if (
      (name === DX ||
        name === DY ||
        name === DZ ||
        name === FX.toLowerCase() ||
        name === FY.toLowerCase() ||
        name === FZ.toLowerCase()) &&
      isNaN(value)
    ) {
      return;
    }

    if ((name === DX || name === DY || name === DZ) && (value < DISTANCE_MIN_POSITIVE || value > DISTANCE_MAX)) {
      return;
    }

    if (
      (name === FX.toLowerCase() || name === FY.toLowerCase() || name === FZ.toLowerCase()) &&
      (value < FORCE_MIN_POSITIVE || value > FORCE_MAX)
    ) {
      return;
    }

    if (
      (name === DX ||
        name === DY ||
        name === DZ ||
        name === FX.toLowerCase() ||
        name === FY.toLowerCase() ||
        name === FZ.toLowerCase()) &&
      !isNaN(value) &&
      value !== ""
    ) {
      value = parseInt(value);
      event.target.value = value;
    }

    data[i] = { ...data[i], [name]: name === "enable" ? checked : value };

    for (let index = 0; index < data.length; index++) {
      // eslint-disable-next-line no-useless-computed-key
      data[index] = { ...data[index], ["enable"]: i === index };
    }

    setIndexSelected(i);
    dispatchMechanics(data, i, FORCE_PARAMETERS_FIELD);
  };

  return (
    <div className="ForcesParameters" {...props}>
      <ForcesParametersHeaderSection data-testid="forces-parameters-header-section" />

      <div className="pb-2 bg-[#E7E6E6] fp-table-border-left fp-table-border-right" />
      <ForceParameterTableSection data-testid="force-parameter-table-section" errorTitle={errorTitle} />
      <div className="pb-[1px] bg-[#E7E6E6] fp-table-border-left fp-table-border-right" />
      <ForcesParametersRows
        data-testid="forces-parameters-rows"
        rows={mechanics.forcesParameters}
        tableRowRemove={tableRowRemove}
        onValUpdate={onValUpdateFP}
        handleInputFocusIn={handleInputFocusIn}
        handleInputFocusOut={handleInputFocusOut}
        indexSelected={mechanics.selectedField === FORCE_PARAMETERS_FIELD ? indexSelected : -1}
      />
      <AddSection
        data-testid="add-section"
        onClick={addRowTable}
        isDisabled={mechanics.forcesParameters.length >= 5 || errorTitle}
      />
    </div>
  );
};

export default ForcesParameters;
